export default __webpack_public_path__ + "static/media/background_viewResponsable_general.f574ad1e.jpg";